export class TemplateFolderSubscription {

  id: number;
  template_folder_id: number;
  share_id: string;

  static fromJson(json): TemplateFolderSubscription {
    const subscription = new TemplateFolderSubscription(json.id, json.template_folder_id, json.share_id);
    return subscription;
  }

  constructor(id?: number, template_folder_id?: number, share_id?: string) {
    this.id = id;
    this.template_folder_id = template_folder_id;
    this.share_id = share_id;
  }

}



// WEBPACK FOOTER //
// ./src/app/template/shared/template-folder-subscription.ts